import {
  FETCH_REFERRAL_COUPON_REQUEST,
  FETCH_REFERRAL_COUPON_FAILURE,
  FETCH_REFERRAL_COUPON_SUCCESS
} from './actions';

export default function referralCouponReducer(state = { id: null }, action) {
  switch (action.type) {
    case FETCH_REFERRAL_COUPON_REQUEST:
    case FETCH_REFERRAL_COUPON_FAILURE:
      return { ...state, id: null };

    case FETCH_REFERRAL_COUPON_SUCCESS:
      return { ...state, id: action.payload.result };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/referralCoupon/reducer.js